import React, { useContext } from 'react'
import { useState, useEffect, useRef } from 'react';


//************** Componentes PrimeReact **************/
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';

//************* Otros Componentes **********************/
import { NumericFormat } from 'react-number-format';
import { InputMask } from 'primereact/inputmask';


//************** Componentes Generales **************/
import { useForm } from '../../../Hooks/useForm';
import Card from '../../../Components/Card/Card';
import Loader from '../../../Components/Loader/Loader';
import AgGrid from '../../../Components/Tables/AgGrid/AgGrid';

//************** Servicios Creados **************/
import { toastShow } from '../../../Services/ToastService';

//************** Consultas API **************/

import { getCAIsProveedor, postProveedorCAI, getProveedor, getCompany, getCompanyCompras, postCambiarProveedorCAI, getTiposCAI } from '../../../API/Proveedores/ProveedoresRequest';

import { getEstadosClientesIPS } from '../../../API/Global/Estados/StatusRequest';
import { setDateTimeSQL1, setDateTimeSQLH } from '../../../Services/FechasService';
import { Checkbox } from 'primereact/checkbox';
import { AuthContext } from '../../../Context/AuthContext/AuthContext';
import { getDateTimeStringSQL } from '../../../Services/Moment/Luxon';


const ModalProveedorCAI = ({ proveedoresCAIDialog, setProveedoresCAIDialog, hideDialog, selected, IdProveedor, InformaicionDropdown = () => { } }) => {

    const [loading, setLoading] = useState(false)
    const toast = useRef(null);
    const [data, setData] = useState([]);
    const [showMessages, setShowMessages] = useState({ error: false });
    const [showDialog, setShowDialog] = useState(false);
    const [estados, setEstados] = useState([]);
    const [habilitar, setHabilitar] = useState(false)
    const [nombreProveedor, setNombreProveedor] = useState('')
    const [infoProveedor, setInfoProveedor] = useState({});
    const [crearCAI, setCrearCAI] = useState(false)
    const [proveedores, setProveedores] = useState([]);
    const [selectedCAI, setSelectedCAI] = useState([]);
    const [tiposCAI, setTiposCAI] = useState([]);
    const { values, handleInputChange, setValues, resetForm, setNumber, handleChange } = useForm({
        IdProveedorCAI: 0,
        IdProveedor: 0,
        NombreSucursal: '',
        NoCAI: null,
        FechaVencimiento: null,
        Fecha: new Date(),
        RangoInicial: null,
        RangoFinal: null,
        Prefijo: null,
        IdEstado: 1,
        ProveedorInternacional: false,
        UserEdit: null,
        IdTipoCAI: 1
    })
    const { userAuth } = useContext(AuthContext)

    const obtenerCAIProveedor = async () => {
        setLoading(true)
        const tempoProveedor = await getProveedor(IdProveedor)

        if (tempoProveedor?.length > 0) {
            setInfoProveedor(tempoProveedor[0])
            setNombreProveedor(tempoProveedor[0]?.CustomerName)

            setCrearCAI(tempoProveedor[0]?.IdStatus !== 1)
        }


        const result = await getCAIsProveedor(IdProveedor)

        setData(result)
        values.IdProveedor = IdProveedor
        values.NombreSucursal = tempoProveedor[0]?.CustomerName
        values.RTN = tempoProveedor[0]?.RTN

        const tempoEstados = await getEstadosClientesIPS()
        setEstados(tempoEstados)

        const tiposCAITempo = await getTiposCAI();
        setTiposCAI(tiposCAITempo)
        setLoading(false)

        const tempoProveedores = await getCompanyCompras()
        if (tempoProveedores.length > 0) {
            setProveedores(tempoProveedores?.map((p) => {
                return {
                    IdProveedor: p.IdCustomer,
                    CustomerName: p.CustomerName,
                    IdStatus: p.IdStatus,
                    EstadoProveedor: p.StatusName
                }
            }))
        }

    }



    const informacionSucursal = (rowData) => {

        setValues({
            ...rowData, FechaVencimiento: rowData.FechaVencimiento === null ? null : new Date(rowData.FechaVencimiento)
        })


    }

    const dialogo = (rowData) => {
        return (
            <div>
                <span style={{ fontSize: 15 }} onDoubleClick={() => informacionSucursal(rowData)}>{rowData.NombreSucursal} </span>
            </div>
        )
    }

    const EstadoTemplate = (StatusName) => {
        switch (StatusName) {
            case "Active":
                return <Tag style={{ width: 80, backgroundColor: "rgb(0, 191, 57)" }} value={StatusName} />
                break;
            case "Inactive":
                return <Tag style={{ width: 80, backgroundColor: "rgb(227, 63, 63)" }} value={StatusName} />
                break;
            case "Delete":
                return <Tag style={{ width: 80, backgroundColor: "rgb(227, 63, 63)" }} value={StatusName} />
                break;


            default:
                return <div><span>{StatusName}</span></div>
                break;
        }
    }

    const TemplateProveedor = ({ rowData = data, oldValue, api }, column) => {

        return <Dropdown
            value={rowData?.IdProveedor}
            options={proveedores}
            optionValue='IdProveedor'
            optionLabel='CustomerName'
            filter filterBy='CustomerName'
            style={{ width: '100%' }}
            onChange={(e) => {

                const tempoProve = proveedores.find((c) => c.IdProveedor === e?.value)
                let tempo = [...data]
                let d = rowData?.length > 0 ? rowData[0] : rowData
                let details = []

                if (tempoProve) {
                    if (selectedCAI?.length > 0) {
                        tempo.forEach((t) => {
                            selectedCAI.forEach(s => {
                                if (t.IdProveedorCAI === s.IdProveedorCAI) {
                                    s.IdProveedor = tempoProve?.IdProveedor
                                    s.CustomerName = tempoProve?.CustomerName
                                }
                            })
                        });
                        details = tempo

                    } else {

                        if (d?.IdProveedorCAI) {
                            d.IdProveedor = tempoProve?.IdProveedor
                            d.CustomerName = tempoProve?.CustomerName
                            const index = data.findIndex(detail => detail.IdProveedorCAI === d.IdProveedorCAI)
                            tempo[index] = d
                            details = [d]
                        }
                    }

                } else {
                    d.IdProveedor = null
                    d.CustomerName = null

                    const index = data.findIndex(detail => detail.IdProveedorCAI === d.IdProveedorCAI)
                    tempo[index] = d
                    details = [d]

                }

                setSelectedCAI([])
                CambiarProveedor(details)
                setData(tempo)
            }}
        />
    }

    const CambiarProveedor = async (detalles) => {
        if (detalles?.length > 0) {
            let datosEnviar = detalles.map((d) => {
                return {
                    IdProveedorCAI: d.IdProveedorCAI,
                    IdProveedor: d.IdProveedor,
                    UserEdit: userAuth.idUser,
                    FechaEdit: getDateTimeStringSQL(new Date())
                }
            });

            const result = await postCambiarProveedorCAI(datosEnviar)
            if (result) {
                if (result[0]?.ERROR === 0) {
                    toastShow(toast, 'success', result[0]?.MSJ)
                    obtenerCAIProveedor()
                } else {
                    toastShow(toast, 'success', result[0]?.MSJ)
                }
            }
        }
        // 1137
    }

    const table = {
        Data: data,
        selected: selectedCAI,
        setSelected: setSelectedCAI,
        Columns: [
            {
                field: 'IdProveedorCAI',
                header: 'IdCAI',
                className: 'Xsmall',
                width: 60

            },
            {
                field: 'IdProveedor',
                header: 'IdProveedor',
                className: 'Xsmall',
                width: 60

            },
            {
                field: 'Nombre Sucursal',
                header: 'Nombre Sucursal',
                className: 'XXXlarge',
                Sumary: 'count',
                Format: "Template",
                body: (rowData) => dialogo(rowData),


            },
            {
                field: 'StatusName',
                header: 'Estado',
                className: 'small',

                Format: "Template",
                body: (rowData) => EstadoTemplate(rowData.StatusName),

            },
            {
                field: 'Prefijo',
                header: 'Prefijo',
                className: 'medium',

            },
            {
                field: 'NoCAI',
                header: 'NoCAI',
                className: 'XXlarge',

            },
            {
                field: 'RangoInicial',
                header: 'Rango Inicial',
                className: 'small',

            },
            {
                field: 'RangoFinal',
                header: 'Rango Final',
                className: 'small',

            },
            {
                field: 'FechaVencimiento',
                header: 'Fecha Vencimiento',
                headerEn: 'Expired Date',
                className: 'medium',

                Format: "Date"
            },
            {
                field: 'CustomerName',
                header: 'Proveedor',
                headerEn: 'Supplier',
                className: 'XXlarge',
                hidden: userAuth.IdRol === 1,
                editable: ({ data }) => {
                    if (userAuth.IdRol === 1)
                        return true
                    return false

                },
                cellEditor: TemplateProveedor,
                Frozen: true,
                alignFrozen: 'right',

            },
        ]
    }

    const verificarCampos = () => {
        let errors = {};
        let isValid = true
        if (!values.NombreSucursal) {
            errors.NombreSucursal = true
            errors.General = true
            isValid = false

        }


        if (values.ProveedorInternacional === false) {
            if (!values.NoCAI) {
                errors.NoCAI = true
                errors.General = true
                isValid = false
            }
            if (!values.Prefijo) {
                errors.Prefijo = true
                errors.General = true
                isValid = false
            }
            if (!values.RangoInicial) {
                errors.RangoInicial = true
                errors.General = true
                isValid = false
            }

            if (!values.RangoFinal) {
                errors.RangoFinal = true
                errors.Rangos = true
                isValid = false
            }

            if (!values.FechaVencimiento) {
                errors.FechaVencimiento = true
                errors.General = true
                isValid = false
            }

            if (values.RangoInicial !== 0) {
                if (values.RangoFinal <= values.RangoInicial) {
                    errors.RangoFinal = true
                    errors.Rangos = true
                    isValid = false
                }
            }
            let tempoData = data?.map((d) => {
                return {
                    ...d,
                    Prefijo: d?.Prefijo?.slice(0, 11)
                }
            });

            if (values.IdEstado !== 7) {
                // tempoData?.find((d) => d.Prefijo === values.Prefijo && d.IdProveedorCAI !== values.IdProveedorCAI && (d.NoCAI === values.NoCAI && d.IdEstado !== 7))
                let CAIIgual = tempoData?.filter((f) => f.IdProveedorCAI !== values.IdProveedorCAI)?.find((d) => d?.Prefijo === values?.Prefijo && (d?.NoCAI === values?.NoCAI && d?.IdEstado !== 7))

                if (CAIIgual) {
                    errors.NoCAI = true
                    errors.General = true
                    isValid = false
                    toastShow(toast, 'error', 'El CAI ingresado ya existe ', 'Ingrese un nuevo CAI')
                }

                // let rangosRepetidos = tempoData?.find(r =>
                //     r.IdEstado !== 7 &&
                //     (
                //         r.IdProveedorCAI !== values.IdProveedorCAI &&
                //         r.NoCAI === values.NoCAI &&
                //         r.Prefijo === values.Prefijo &&
                //         (
                //             (values.RangoInicial >= r.RangoInicial && values.RangoInicial <= r.RangoInicial) ||
                //             (values.RangoFinal >= r.RangoFinal && values.RangoFinal <= r.RangoFinal) ||
                //             (values.RangoInicial <= r.RangoInicial && values.RangoFinal >= r.RangoFinal)
                //         )
                //     )
                // );

                let rangosRepetidos = tempoData?.filter((f) => f.IdProveedorCAI !== values.IdProveedorCAI)?.find(r =>
                    r.IdEstado !== 7 &&
                    (
                        r.NoCAI === values.NoCAI &&
                        r.Prefijo === values.Prefijo &&
                        (
                            (values.RangoInicial >= r.RangoInicial && values.RangoInicial <= r.RangoInicial) ||
                            (values.RangoFinal >= r.RangoFinal && values.RangoFinal <= r.RangoFinal) ||
                            (values.RangoInicial <= r.RangoInicial && values.RangoFinal >= r.RangoFinal)
                        )
                    )
                );

                if (rangosRepetidos) {
                    errors.RangoInicial = true
                    errors.RangoFinal = true
                    errors.Rangos = true
                    isValid = false
                    toastShow(toast, 'error', 'Ya existe un CAI con el mismo rango', 'Ingrese rangos validos')
                }
            }

        }
        if (!values.IdEstado) {
            errors.IdEstado = true
            errors.General = true
            isValid = false
        }
        setShowMessages({ ...errors, error: !isValid });
        if (Object.keys(errors).length === 0 && isValid) {
            return false
        } else {
            // toastShow(toast, 'warn', 'Error', 'Por favor, complete los campos requeridos');
            return true
        }
    }

    const datosIniciales = () => {
        values.IdProveedorCAI = 0
        values.IdProveedor = 0
        values.NombreSucursal = ''
        values.NoCAI = ''
        // values.FechaVencimiento= new Date()
        // values.Fecha= new Date()
        values.RangoInicial = 0
        values.RangoFinal = 0
        values.Prefijo = ''
        values.IdEstado = 1
        values.ProveedorInternacional = false
        values.IdTipoCAI = 1
    }



    const guardarInformacionProveedor = async () => {

        const verificar = verificarCampos()
        if (verificar) {
            toastShow(toast, 'error', 'Error', 'Llenar los campos requeridos');
            return;
        } else {
            // values.FechaVencimiento = setDateTimeSQL1(values.FechaVencimiento)

            setLoading(true)
            let sucursalProveedor = {
                ...values,
                Prefijo: values.ProveedorInternacional ? null : values.Prefijo,
                RangoFinal: values.ProveedorInternacional ? null : values.RangoFinal,
                RangoInicial: values.ProveedorInternacional ? null : values.RangoInicial,
                IdTipoCAI: values?.IdTipoCAI,
                FechaVencimiento: values.FechaVencimiento !== null ? setDateTimeSQLH(values.FechaVencimiento) : null,
                UserEdit: userAuth.idUser
            }
            const result = await postProveedorCAI(sucursalProveedor)

            if (result) {
                toastShow(toast, 'success', 'Datos Agregados', 'Datos Agregados Correctamente');
                obtenerCAIProveedor()
                // setValues({})
                datosIniciales()
                setLoading(false)
                InformaicionDropdown()
                return true;
            } else {
                toastShow(toast, 'error', 'Error', 'Error al agregar los valores');
            }
            setLoading(false)


        }
    }

    const handleButtonClick = () => {
        window.open(`https://oficinavirtual.sar.gob.hn/fac/validador-doc-fiscales/`, '_blank');
    };

    useEffect(() => {
        if (proveedoresCAIDialog) {
            obtenerCAIProveedor()
        } else {
            setValues({})
            resetForm({})
            setShowMessages({ error: false })
            setHabilitar(false)
            setCrearCAI(false)
        }

    }, [proveedoresCAIDialog])


    const RTNEmpresa = values?.RTN && values.RTN.trim() !== '' ? `- RTN: ${values.RTN}` : '';

    return (
        <div>

            <Dialog visible={proveedoresCAIDialog} breakpoints={{ '960px': '70vw', '640px': '100vw' }} style={{ width: '90vw', height: '85vh' }}
                onHide={hideDialog} header={<div className='d-flex gap pt-2' style={{ alignItems: 'center' }}>
                    <h4>Proveedor {nombreProveedor} {RTNEmpresa} </h4>
                    <Button icon="pi pi-copy" className="p-ml-2" onClick={() => navigator.clipboard.writeText(values.RTN)} tooltip="Copiar RTN" style={{ height: 35 }} />
                    <Button label={infoProveedor?.StatusName} style={{ backgroundColor: infoProveedor?.IdStatus === 1 ? 'rgb(0, 191, 57)' : 'rgb(227, 63, 63)', width: 100, height: 35 }} />

                </div>}>



                <div className='d-flex flex-column' >
                    <div className='d-flex flex-row'>
                        <span className="p-float-label">
                            <Card
                                titulo="Nombre Sucursal"
                                contenido={<div>
                                    <InputText
                                        value={values.NombreSucursal}
                                        onChange={(e) => handleInputChange(e, "NombreSucursal")}
                                        className={classNames({ 'p-invalid': showMessages?.NombreSucursal })}
                                        style={{ width: "45vw" }} disabled={crearCAI}
                                    />
                                </div>}
                            />
                            {/* <label>NombreSucursal</label> */}
                        </span>
                        <span className='mx-2'>
                            <Card
                                titulo='Internacional'
                                contenido={<div className='d-flex align-items-center ' style={{ height: 40, justifyContent: 'center' }}  >
                                    <Checkbox
                                        checked={values.ProveedorInternacional}
                                        onChange={(e) => {
                                            handleChange(e.checked, 'ProveedorInternacional')
                                            setHabilitar(e.checked)

                                        }}
                                        className={classNames({ 'p-invalid': showMessages?.ProveedorInternacional }, 'mx-2')}
                                        disabled={crearCAI}

                                    />
                                    <label> Es Proveedor Internacional</label>
                                </div>}
                            />
                        </span>
                        <span className="p-float-label" style={{ width: "11%" }}>
                            <Card
                                titulo="Estado"
                                contenido={<div>
                                    <Dropdown
                                        value={values.IdEstado}
                                        onChange={(e) => handleInputChange(e, "IdEstado")}
                                        className={classNames({ 'p-invalid': showMessages?.IdEstado })}
                                        style={{ width: "100%" }}
                                        options={estados}
                                        optionValue='IdStatus'
                                        optionLabel='StatusName'
                                        disabled={crearCAI}
                                    />
                                </div>} />

                            {/* <label>FechaVencimiento</label> */}
                        </span>


                        <span className='d-flex align-items-end '>
                            <Button onClick={handleButtonClick} className='mx-4' icon="ri-verified-badge-line" style={{ height: 40 }} tooltip='Verificador SAR' />
                        </span>


                        {showMessages.General && <div className="p-error">{('Completar Campos Obligatorios')}</div>}
                    </div>
                    <div className='d-flex flex-row' >
                        <span className="p-float-label mx-2">
                            <Card
                                titulo="No CAI"
                                contenido={<div>
                                    <InputMask id="basic" mask="******-******-******-******-******-**"
                                        value={values.NoCAI} placeholder="000000-000000-000000-000000-000000-00"
                                        onChange={(e) => handleInputChange(e, "NoCAI")}
                                        className={classNames({ 'p-invalid': showMessages?.NoCAI })}
                                        style={{ width: "20vw" }} disabled={habilitar || crearCAI}
                                    />
                                </div>}
                            />

                            {/* <label>No.CAI</label> */}
                        </span>
                        <span className="p-float-label">
                            <Card
                                titulo="Prefijo"
                                contenido={<div>
                                    <InputMask id="basic" mask="999-999-99-" value={values.Prefijo} placeholder="999-999-99-999" onChange={(e) => handleInputChange(e, "Prefijo")}
                                        className={classNames({ 'p-invalid': showMessages?.Prefijo })}
                                        style={{ width: "100%" }} disabled={habilitar || crearCAI}
                                    />
                                </div>}
                            />
                        </span>
                        <span className="p-float-label ">
                            <Card
                                titulo="Rango Inicial"
                                contenido={<div>
                                    <NumericFormat
                                        value={values.RangoInicial}
                                        onValueChange={(values, sourceInfo) => handleChange(values.floatValue, "RangoInicial")}
                                        className={classNames({ 'p-invalid': showMessages?.RangoInicial }, "InputNumberStyle")} disabled={habilitar || crearCAI}
                                    />

                                </div>}
                            />
                        </span>
                        <span className="p-float-label mx-2">
                            <Card
                                titulo="Rango Final"
                                contenido={<div>
                                    <NumericFormat
                                        value={values.RangoFinal}
                                        onValueChange={(values, sourceInfo) => handleChange(values.floatValue, "RangoFinal")}
                                        className={classNames({ 'p-invalid': showMessages?.RangoFinal }, "InputNumberStyle")}
                                        style={{ height: 40 }} disabled={habilitar || crearCAI}
                                    />
                                </div>}
                            />
                        </span>
                        <span className="p-float-label">
                            <Card
                                titulo="Fecha Vencimiento"
                                contenido={<div>
                                    <Calendar
                                        value={values.FechaVencimiento}
                                        onChange={(e) => handleInputChange(e, "FechaVencimiento")}
                                        className={classNames({ 'p-invalid': showMessages?.FechaVencimiento })} dateFormat='dd/mm/yy'
                                        style={{ height: 40 }} showIcon showButtonBar disabled={habilitar || crearCAI}
                                    />
                                </div>} />

                            {/* <label>FechaVencimiento</label> */}
                        </span>

                        <span className="p-float-label" style={{ width: "11%" }}>
                            <Card
                                titulo="Tipo CAI"
                                contenido={<div>
                                    <Dropdown
                                        value={values?.IdTipoCAI}
                                        onChange={(e) => handleInputChange(e, "IdTipoCAI")}
                                        className={classNames({ 'p-invalid': showMessages?.IdTipoCAI })}
                                        style={{ width: "100%" }}
                                        options={tiposCAI}
                                        optionValue='IdTipoCAI'
                                        optionLabel='TipoCAI'
                                        disabled={crearCAI}
                                    />
                                </div>} />

                            {/* <label>FechaVencimiento</label> */}
                        </span>


                        <span className='d-flex align-items-end '>
                            <Button onClick={() => guardarInformacionProveedor()} className='mx-4' icon="ri-save-line" style={{ height: 40 }} tooltip='Guardar' disabled={crearCAI} />
                        </span>

                        {/* <i class="ri-verified-badge-line"></i> */}

                    </div>
                    {showMessages.Rangos && <div className="p-error">{('La cantidad del Rango Final debe ser mayor al Rango Inicial')}</div>}
                </div>
                <div id="ProveedoresCAI">
                    <Toast ref={toast} />
                    <Loader loading={loading} querySelector="#ProveedoresCAI" />
                    <div className='pt-2' style={{ height: "58vh" }}>
                        <AgGrid table={table} />
                    </div>
                </div>
            </Dialog>

        </div>
    )
}

export default ModalProveedorCAI
